import axios from "axios";
import qs from "qs";

import { api } from "@/plugins/util";

/**
 * 查询企业列表
 * @param type          搜索类型
 * @param id            企业主键
 * @param companyName   企业名称
 * @param contactMobile 联系人电话
 * @param pageNum       页码
 * @param pageSize      每页条数
 * @returns {AxiosPromise<any>}
 */
export function searchCompany({
                                  type,
                                  verifyStatus,
                                  companyName,
                                  timeStart, timeEnd,
                                  pageNum,
                                  pageSize,
                                  regionCode,uscc
                              }) {
    return axios.post(api + "/company/search",
        qs.stringify({
            type,
            verifyStatus,
            companyName,
            timeStart, timeEnd,
            pageNum,
            pageSize,
            regionCode,uscc
        }))
}

/**
 * 查询区域数据
 * @returns {AxiosPromise<any>}
 */
export function getRegionList() {
    return axios.get(api + "/company/getRegionList", {})
}


/**
 * 重置密码
 * @param id
 * @returns {AxiosPromise<any>}
 */
export function initPassword(id) {
    return axios.post(api + "/company/initPassword",
        qs.stringify({
            id
        }))
}

/**
 * 停用/启用企业
 * @param id
 * @returns {AxiosPromise<any>}
 */
export function reserveCompany(id, status) {
    return axios.post(api + "/company/reverse",
        qs.stringify({
            id,
            status
        }))
}

/**
 * 更新企业或者添加企业
 * @param type
 * @param id
 * @returns {AxiosPromise<any>}
 */
export function insertCompany({
                                  type,
                                  id,
                                  companyName,
                                  socialCreditUnicode,
                                  legalRepresentative,
                                  legalIdCard,
                                  legalAddress,
                                  registeredCapital,
                                  businessRange,
                                  companyCreateTime,
                                  contact,
                                  contactMobile,
                                  contactPassword,
                                  contactIdCard,
                                  businessLicenseUrl,
                                  legalIdCardFrontUrl,
                                  legalIdCardBackUrl,
                                  street
                              }) {
    if (type == "add") {
        return axios.post(api + "/company/add",
            {
                companyName,
                socialCreditUnicode,
                legalRepresentative,
                legalIdCard,
                legalAddress,
                registeredCapital,
                businessRange,
                companyCreateTime,
                contact,
                contactMobile,
                contactPassword,
                contactIdCard,
                businessLicenseUrl,
                legalIdCardFrontUrl,
                legalIdCardBackUrl,
                "deleteFlag": 1,
                "verifyStatus": 2,
                street
            })
    } else if (type == "update") {
        return axios.post(api + "/company/update", {
            id,
            companyName,
            legalRepresentative,
            legalIdCard,
            legalAddress,
            registeredCapital,
            businessRange,
            companyCreateTime,
            contact,
            contactMobile,
            contactPassword,
            contactIdCard,
            businessLicenseUrl,
            legalIdCardFrontUrl,
            legalIdCardBackUrl,
            deleteFlag: 0,
            verifyStatus: 0,
            street
        })
    }

    return axios.post(api + "/company/reverse",
        qs.stringify({
            id
        }))
}
/**
 * 更新企业或者添加企业
 * @param type
 * @param id
 * @returns {AxiosPromise<any>}
 */
export function insertCompany1({
                                   companyName,
                                   socialCreditUnicode,
                                   legalRepresentative,
                                   legalIdCard,
                                   legalAddress,
                                   registeredCapital,
                                   businessRange,
                                   companyCreateTime,
                                   contact,
                                   contactMobile,
                                   contactPassword,
                                   contactIdCard,
                                   businessLicenseUrl,
                                   legalIdCardFrontUrl,
                                   legalIdCardBackUrl
                               }) {
    return axios.post(api + "/company/add1",
        {
            companyName,
            socialCreditUnicode,
            legalRepresentative,
            legalIdCard,
            legalAddress,
            registeredCapital,
            businessRange,
            companyCreateTime,
            contact,
            contactMobile,
            contactPassword,
            contactIdCard,
            businessLicenseUrl,
            legalIdCardFrontUrl,
            legalIdCardBackUrl,
            "deleteFlag": 1,
            "verifyStatus": 0
        })
}

/**
 * 更新企业或者添加企业
 * @param type
 * @param id
 * @returns {AxiosPromise<any>}
 */
export function insertCompany2({
                                   companyName,
                                   socialCreditUnicode,
                                   legalRepresentative,
                                   legalIdCard,
                                   registeredCapital,
                                   businessRange,
                                   companyCreateTime,
                               }) {
    return axios.post(api + "/company/add3",
        {
            companyName,
            socialCreditUnicode,
            legalRepresentative,
            legalIdCard,
            registeredCapital,
            businessRange,
            companyCreateTime,
            "deleteFlag": 1,
            "verifyStatus": 0
        })
}

/**
 * 图片上传
 * @param id
 * @returns {AxiosPromise<any>}
 */
export function uploadImg(id) {
    return axios.post(api + "/company/initPassword",
        qs.stringify({
            id
        }))
}

/**
 * 审核企业信息
 * @param verifyStatus          审核结果
 * @param verifyRemark          审核备注
 * @returns {AxiosPromise<any>}
 */
export function verifyCompany({
                                  verifyStatus,
                                  verifyRemark,
                                  id
                              }) {
    return axios.post(api + "/company/verify",
        qs.stringify({
            verifyStatus,
            verifyRemark,
            id
        }))
}

export function findOldInformation({
                                       id,
                                       pageNum,
                                       pageSize
                                   }) {
    return axios.get(api + "/company/findHistory", {
            params:{
                pageSize,
                pageNum,
                id
            }
        })
}

/**
 * 获取企业信息
 * @param uscc
 * @returns {AxiosPromise<any>}
 */
export function getCompanyInfo(uscc) {
    return axios.get(api + "/company/getCompanyInfo",{
        params:{
            uscc
        }
    })
}

export function exportExcelByEnterprise({
                                            type,
                                            verifyStatus,
                                            companyName,
                                            timeStart,
                                            timeEnd,
                                            pageNum,
                                            pageSize,
                                            regionCode,uscc
                                        }) {
    return axios.get(api + "/company/exportExcelByEnterprise",{
        params:{
            type,
            verifyStatus,
            companyName,
            timeStart,
            timeEnd,
            pageNum,
            pageSize,
            regionCode,uscc
        },responseType:'blob'})
}

/**
 * 区域融资统计
 * @param startTime
 * @param endTime
 * @returns {AxiosPromise<any>}
 */
export function getStatisticsDataByRegion({startTime,endTime}){
    return axios.get(api + "/company/getStatisticsDataByRegion",{
        params:{
            startTime,
            endTime
        }
    })
}


/**
 * 导出区域融资统计
 */
export function exportRegionData({startTime,endTime}){
    return axios.get(api + "/company/exportRegionData",{
        params:{
            startTime,
            endTime
        },
        responseType:'blob'
    })
}

export function getYxdwCompanyLicensePageList(){
    return axios.get(api + "/company/getYxdwCompanyLicensePageList")
}

/**
 * 查询企业列表
 * @param type          搜索类型
 * @param id            企业主键
 * @param companyName   企业名称
 * @param contactMobile 联系人电话
 * @param pageNum       页码
 * @param pageSize      每页条数
 * @returns {AxiosPromise<any>}
 */
export function searchLicense({

                                  companyName,
                                  timeStart, timeEnd,
                                  pageNum,
                                  pageSize
                              }) {
    return axios.post(api + "/companyLicense/search",
        qs.stringify({
            companyName,
            timeStart,
            timeEnd,
            pageNum,
            pageSize
        }))
}

export function uploadEnterpriseAuthFile(data){
    return axios.post(api + "/companyLicense/uploadEnterpriseAuthFile",data)
}

/**
 * 取消授权接口
 * @param account 用户
 * @param licenseId 授权id
 * @return
 */
export function getCancelAjax(licenseId,uscc) {
    return axios.get(api + "/companyLicense/cancelLicense",{
        params:{
            licenseId,
            uscc
        }
    })
}

/**
 * 授权协议统计查询各个区县的授权数和企业数
 * @param startTime
 * @param endTime
 * @returns {AxiosPromise<any>}
 */
export function getAuthedEnterpriseStatistics({startTime,endTime}){
    return axios.get(api + "/companyLicense/getAuthedEnterpriseStatistics",{
        params:{
            startTime,
            endTime
        }
    })
}
